import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import {UsuarioLogadoStorageService} from "../storage/usuario/usuario-logado-storage.service";
import { PermUsuario } from '../model/usuario/perm-usuario';
import { UsuarioLogado } from '../model/usuario/usuario-logado';
import { AlertService } from '../service/shared/alert.service';
import { UsuarioMenuStorageService } from '../storage/usuario/usuario-menu-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardPermissionService implements CanActivateChild {

  _permissoes: PermUsuario[];
  _usuarioLogado: UsuarioLogado;

  constructor(
    private _router: Router,
    private _alertService: AlertService,
    private _usuarioMenuStorageService: UsuarioMenuStorageService,
    private _usuarioLogadoStorageService: UsuarioLogadoStorageService
  ){}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this._usuarioLogado = this._usuarioLogadoStorageService.get();
    let rotaArray = state.url.split("/");  
    if(rotaArray.length > 0 && rotaArray[0].length == 0){
      rotaArray.splice(0,1)
    }
    let menuItens = this._usuarioMenuStorageService.get()[0];
    if(menuItens){
      for (const menuItem of menuItens.main) {
        if(menuItem.state == rotaArray[0]){
          if(rotaArray.length == 1){
            return true;
          }else if(rotaArray.length == 2 && menuItem.children){
            for (const menuItemChildren of menuItem.children) {
              if(menuItemChildren.state == rotaArray[1]){
                return true
              }
            }
          }
        }
      }
    }

    this._alertService.message('Aviso!', 'Usuário sem permissão para acessar.');
    return this._router.parseUrl('');
  }
}
